import {
  ChangesSavedNotification,
  GeneralErrorNotification,
} from '@storeOld/reducers/notification'
import { call, put, select } from 'redux-saga/effects'

import { NestClient } from '@/nest'
import { type AccountActions, InternalAccountActions } from '../actions'
import { selectEmailChoices } from '../selectors'
import type { EmailChoices } from '../types'

// A switch moves at once and goes back if the server did not save it
export function* updateEmails({
  payload: change,
}: ReturnType<typeof AccountActions.updateEmails>) {
  const before: EmailChoices | null = yield select(selectEmailChoices)

  if (!before) {
    return
  }

  yield put(
    InternalAccountActions.setEmails({
      all: change.all ?? before.all,
      topics: { ...before.topics, ...change.topics },
    })
  )

  try {
    const saved: EmailChoices = yield call(
      NestClient.account.updateEmails,
      change
    )
    yield put(InternalAccountActions.setEmails(saved))
    yield put(ChangesSavedNotification)
  } catch (e) {
    console.error('Error while saving email settings', e)
    yield put(InternalAccountActions.setEmails(before))
    yield put(GeneralErrorNotification)
  }
}
